import React from 'react';
import integrately from '../../images/integrations/Integrately.svg';
import IntegrationBot from '../../components/integrationn/index';

const Integrately = () => <IntegrationBot botLogo={integrately} botName={'Integrately'} />;

export default Integrately;
